module.exports = __webpack_public_path__ + "static/media/wge1.png.030403f9.jpg";